import React, { createContext, useContext, useState } from 'react';
import { getLikes } from './Components/Galeria/Galeria.Api';

const StoreContext = createContext();

const DEFAULT_STATE = {
	seed :Math.floor(Math.random() * 100000),
	isAdmin:false,
	isLoading:false,
	items:[],
	cloud:undefined,
	query:{q:'',tags:[],nsfw:0},
	currentItem:{},
	viewerIsOpen:false,
	myLikes:getLikes(),
}


export function StoreProvider({ children }) {
  const [state, setState] = useState(DEFAULT_STATE); // initial state

  function updateState(newState) {
    setState(prevState => ({ ...prevState, ...newState }));
  }

  return (
    <StoreContext.Provider value={{ state, updateState }}>
      {children}
    </StoreContext.Provider>
  );
}

export function useDispatchSync() {
  const { updateState } = useContext(StoreContext);

  return function(action) {
    if (typeof action === 'function') {
      action(updateState);
    } else {
      updateState(action);
    }
  }
}

export function useDispatch() {
  const { updateState } = useContext(StoreContext);
  return function(action) {
    if (typeof action === 'function') {
      action(updateState);
    } else {
      updateState(action);
    }
  };
}

export function useSelector(selector) {
  const { state } = useContext(StoreContext);

  return selector(state);
}
